import React from 'react';

interface Props {
  className: string;
  isWhite?: boolean;
  hasUnderLine?: boolean;
}

const CurveLine: React.FC<Props> = ({ className, isWhite, hasUnderLine = true }: Props) => {
  return (
    <div className={className}>
      <span>
        <svg
          width='113'
          height='8'
          viewBox='0 0 113 8'
          fill='none'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            className={isWhite ? 'stroke-white' : ''}
            d='M113 3.53003C110 3.53003 107.21 5.04003 104.44 6.18003C102.38 7.03003 99.99 6.34003 98.75 4.49003C97.65 2.85003 96.68 1.03003 94.5 1.03003C90.56 1.03003 90.56 7.03003 86.62 7.03003C82.68 7.03003 82.68 1.03003 78.74 1.03003C74.8 1.03003 74.8 7.03003 70.86 7.03003C66.92 7.03003 66.92 1.03003 62.98 1.03003C59.04 1.03003 59.04 7.03003 55.11 7.03003C51.18 7.03003 51.17 1.03003 47.24 1.03003C43.31 1.03003 43.3 7.03003 39.37 7.03003C35.44 7.03003 35.43 1.03003 31.5 1.03003C27.57 1.03003 27.56 7.03003 23.62 7.03003C19.68 7.03003 19.68 1.04003 15.75 1.04003C11.82 1.04003 11.81 7.04003 7.88 7.04003C3.95 7.04003 3.94 1.04003 0 1.04003'
            stroke='black'
            strokeMiterlimit='10'
          />
        </svg>
      </span>
      {hasUnderLine && (
        <hr className={`mb-px w-full ${isWhite ? 'border-white' : 'border-black'}`} />
      )}
    </div>
  );
};

export default CurveLine;
